import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import './BuySellComponent.css';
import BuySellOrderConfirmationModal from '@alphapoint/apex-web/lib/components/Retail/RetailBuySell/BuySellOrderConfirmationModal';
import BuySellInstrumentSelector from './BuySellInstrumentSelector';
import BuySellOrderButton from '@alphapoint/apex-web/lib/components/Retail/RetailBuySell/BuySell/BuySellOrderButton';
import BuySellPresetValuesRowsContainer from '@alphapoint/apex-web/lib/components/Retail/RetailBuySell/BuySell/BuySellPresetValuesRows';
import BuySellCustomRowContainer from '@alphapoint/apex-web/lib/components/Retail/RetailBuySell/BuySell/BuySellCustomRow';

const baseClasses = getBEMClasses('buy-sell');

class BuySellComponent extends React.Component {
  render() {
    const { t } = this.props;

    const {
      handleSubmit,
      submitting,
      extraInfoComponent,
      displayInstrumentSelector,
      themeModifier,
      amountHeader,
      formHeader,
      hideKYC,
      customKYCmessage,
    } = this.props;
    return (
      <form className={baseClasses('container', themeModifier)} onSubmit={handleSubmit}>
        {formHeader && <div className={baseClasses('form-header', themeModifier)}>{formHeader}</div>}
        {displayInstrumentSelector && <BuySellInstrumentSelector baseClasses={baseClasses} />}
        {amountHeader && <div className={baseClasses('amount-header', themeModifier)}>{t(amountHeader)}</div>}
        <div className={baseClasses('amount-container', themeModifier)}>
          <BuySellPresetValuesRowsContainer baseClasses={baseClasses} />

          <BuySellCustomRowContainer baseClasses={baseClasses} themeModifier={themeModifier} />

          <BuySellOrderConfirmationModal />
        </div>
        {extraInfoComponent && (
          <div className={baseClasses('extra-info-container', themeModifier)}>{extraInfoComponent}</div>
        )}
        <BuySellOrderButton
          baseClasses={baseClasses}
          handleSubmit={handleSubmit}
          submitting={submitting}
          hideKYC={hideKYC}
          customKYCmessage={customKYCmessage}
        />
      </form>
    );
  }
}

BuySellComponent.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  displayInstrumentSelector: PropTypes.bool,
  extraInfoComponent: PropTypes.element,
  themeModifier: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
  hideKYC: PropTypes.bool,
  customKYCmessage: PropTypes.string,
};

BuySellComponent.defaultProps = {
  displayInstrumentSelector: true,
  hideKYC: false,
  amountHeader: 'Amount',
};

export default withTranslation('core')(BuySellComponent);
